import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setCandidate } from '../actions/candidate.actions';
import { Candidate } from '../models/candidate.model';

export const initialState: Candidate = null;

const reducer = createReducer(initialState,
  on(setCandidate, (state, candidate) => candidate)
);

export const fromCandidate = {
  selectCandidateState: createFeatureSelector<Candidate>('candidate'),
};

export function candidateReducer(state, action) {
  return reducer(state, action);
}
